import { render } from "./MarkdownCell.vue?vue&type=template&id=0c724f58"
import script from "./MarkdownCell.vue?vue&type=script&lang=js"
export * from "./MarkdownCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__